// extracted by mini-css-extract-plugin
export var animationContainer = "_iw-0";
export var asteriskIcon = "_iw-8";
export var conversationLeftSection = "_iw-4";
export var conversationListItem = "_iw-3";
export var conversationMiddleSection = "_iw-5";
export var conversationRightSection = "_iw-6";
export var detailsContent = "_iw-1";
export var listContainer = "_iw-7";
export var modalContent = "_iw-2";